import React , { useState, useEffect, useRef } from 'react';
import budgetsection from '../images/common/budget.png';
import adminsection from '../images/common/settings.png';
import menu from '../images/common/menu.png';
import icon from '../images/common/icon.png';
import help from '../images/common/help-blue.png';
import account from '../images/common/account.png';

import img_menu_arrows from '../images/common/arrows.png';
import img_menu_budget from '../images/common/budget.svg';
import img_menu_report from '../images/common/report.svg';

import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../css/Login.css';
import { Router, Switch, Route, Link } from "react-router-dom";
import history from "../Components/history";
import BudgetList from "../Components/budget_components/BudgetList";
import ReportList from "../Components/budget_components/ReportList";
import MenuPopup from '../Components/admin_components/pages/customComponents/MenuPopup';
import SelectProfile from '../Components/login_components/SelectProfile'
import AppConfig from '../config';

const appName = "";///ArchicubedWeb //Production
//const appName = "/"; Development
const LoadBudgetMenu = (section) =>{
    history.push(appName + (section != '' ? '/'+section : '')) ;
}
const LoadSection = (section) =>{
    history.push(appName + (section != '' ? '/'+section : '')) ;
}


//ArchicubedWeb
// const heightSet = document.body.scrollHeight - margin;
function SignInProfile() {
    if(localStorage.getItem("token") == null){   
        history.push('/login') ;
    }
    const [show,setShow]=useState(false);

    const refMenuPopup = useRef();

    const ToggleMenuSection = () =>{
        setShow(! show); 
    };

    const componentRef1 = useRef();
    const componentRef2 = useRef();

    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
        function handleClick(e) {
            if(componentRef1 && componentRef1.current){
                const ref1 = componentRef1.current
                const ref2 = componentRef2.current
                const ref3 = refMenuPopup.current.componentRef.current
                if(!ref1.contains(e.target) && !ref2.contains(e.target) && !ref3.contains(e.target)){
                    refMenuPopup.current.setShowUser(false); 
                    refMenuPopup.current.setshowHelp(false);
                }
            }
        }
    }, []);

    return (<Router  history={history} basename="/">
      <SelectProfile data={{profileSelected:LoadSection.bind(this)}} ></SelectProfile>
      <div className="App">
        
        <div className="div-header">
            <div  className="div-header-menu" style={{cursor:'pointer'}} onClick={() => ToggleMenuSection()} >
                <img src={menu} onClick={() => ToggleMenuSection()}></img>
            </div>
            <div className="div-header-info" >                
                <img src={icon}></img>
                <label className="lbl-header-info">{AppConfig.brandName} Data & Budget Tool</label>
             </div>
             <div className="div-header-help push" style={{cursor:'pointer'}} ref={componentRef1}>
                <img src={help} onClick={() => refMenuPopup.current.ToggleMenuSectionHelp()}></img>
            </div>
            <div className="div-header-account" style={{cursor:'pointer'}} ref={componentRef2}>
                <img src={account} onClick={() => refMenuPopup.current.ToggleMenuSectionUser()}></img>
            </div>
          </div>

          <div className="div-body">
            <div className={show ? "div-menu-sections" : "div-menu-sections hidden" }  >
                <div className="div-menu-sections_details div-menu-sections_budget" onClick={() => LoadSection('budget')} >
                        <img src={budgetsection}></img>
                        <label>Data & Budget Tool</label>
                </div>
                <div className="div-menu-sections_details div-menu-sections_admin" onClick={() => LoadSection('admin')} >
                    <img src={adminsection}></img>
                    <label>Administration Center</label>
                </div>

            </div>

            <MenuPopup ref={refMenuPopup} />

          <div className="div-body-menu">
          <div className="div-menu-quickaccess">              
             <div class="div-menu-details" style={{cursor:'pointer'}}>
                    <label style={{cursor:'pointer'}}>Menu</label>
                </div> 
                <div class="div-menu-quickaccess-img push">
                <img src={img_menu_arrows}></img>
                </div>               
            </div>
            
          </div>
          <div className="div-body-details">         
            </div>
        </div>  
        </div>
       </Router>
    );
}

export default SignInProfile;
